import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { billingSplitQueryKey } from 'Data/keys/QueryKeys';
import { RateioApi } from 'Data/Rateio.api';
import toastHandler from 'Utils/toastHandler';
import { getApiErrorMessage } from 'Utils/ApiErrorUtils';
import i18n from 'i18n';
import { useRateioScope } from './RateioScope';

// Reenvio do pedido de ciência nos Termos de Uso (matriz ou SPE), no tenant do
// RateioScope — o do usuário, ou o selecionado no /adm.
export const useMutationResendTerms = () => {
  const { tenantId } = useRateioScope();

  const { mutate, isPending, variables } = useMutation({
    // speId ausente = matriz.
    mutationFn: (speId?: string) => RateioApi.resendTermsAcceptance(speId, tenantId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: billingSplitQueryKey(tenantId) });
      toastHandler.showSuccess(i18n.t('faturamento:terms.resendSuccess'));
    },
    onError: (error: unknown) => {
      toastHandler.showError(getApiErrorMessage(error, i18n.t('faturamento:terms.resendError')));
    },
  });

  return {
    resendTerms: mutate,
    isResending: isPending,
    // Qual pedido está sendo reenviado, para o loading ficar só no botão certo.
    resendingSpeId: isPending ? variables ?? 'headquarters' : undefined,
  };
};
